

import store from "../../store/store"

const getKayitliYukDiff = () => {

    const {
        kayitliYukRouteSync,
        kayitliYuklerYukDataSync,
        kayitliYuklerPaketlemeDataSync,
        kayitliYuklerAracDataSync,
        kayitliYuklerPaymentDataSync,
        isFromKayitliYuk
    } = store.getState().kayit

    const {
        route,
        aracData,
        paymentData,
        yukData,
        paketlemeData,
        routeDistance,
        isLoadingAddLoad
    } = store.getState().addLoad

    if(isFromKayitliYuk){

    //! yukData
    const errorListYukData = [
        kayitliYuklerYukDataSync?.agirlikBirim?.value === yukData?.agirlikBirim?.value,
        kayitliYuklerYukDataSync?.toplamAgirlik === yukData?.toplamAgirlik,
        kayitliYuklerYukDataSync?.toplamHacim === yukData.toplamHacim,
        kayitliYuklerYukDataSync?.ustUsteYuklenmesin === yukData.ustUsteYuklenmesin,
        kayitliYuklerYukDataSync?.yukADR === yukData?.yukADR,
        kayitliYuklerYukDataSync?.yukAdrDescription === yukData?.yukAdrDescription,
        kayitliYuklerYukDataSync?.yukDesc === yukData?.yukDesc,
        kayitliYuklerYukDataSync?.yukTuru === yukData?.yukTuru,
        kayitliYuklerYukDataSync?.yuklemeTuru?.value === yukData?.yuklemeTuru?.value,
        kayitliYuklerYukDataSync?.yukunDegeri === yukData?.yukunDegeri,
    ]


    //! paymentData
    const errorListPaymentData = [
        kayitliYuklerPaymentDataSync?.fiyatlandirmaType === paymentData?.fiyatlandirmaType,
        kayitliYuklerPaymentDataSync?.fiyatYayinlansin === paymentData?.fiyatYayinlansin,
        kayitliYuklerPaymentDataSync?.komisyonDurumu?.value === paymentData?.komisyonDurumu?.value,
        kayitliYuklerPaymentDataSync?.komisyonMiktari === paymentData?.komisyonMiktari,
        kayitliYuklerPaymentDataSync?.odemeSekli?.text === paymentData?.odemeSekli?.text,
        kayitliYuklerPaymentDataSync?.odemeSekliDigerAciklama === paymentData?.odemeSekliDigerAciklama,
        kayitliYuklerPaymentDataSync?.yakitDurumu === paymentData?.yakitDurumu,
        kayitliYuklerPaymentDataSync?.yakitOrani === paymentData?.yakitOrani,
    ]

    //! aracData
    const errorListAracData = [
        kayitliYuklerAracDataSync?.aracSayisi === aracData?.aracSayisi,
        kayitliYuklerAracDataSync?.aracTypeId === aracData?.aracTypeId,
        kayitliYuklerAracDataSync?.kasaTypeId === aracData?.kasaTypeId,
        kayitliYuklerAracDataSync?.zeminType?.value === aracData?.zeminType?.value,
    ]

    //! paketlemeData
    const errorListPaketlemeData = kayitliYuklerPaketlemeDataSync?.map((item, i) => {
        return (item?.activePaketlemeTypeId === paketlemeData[i]?.activePaketlemeTypeId) &&
                    item.list.map((listItem, listI) => {
                        return  (listItem?.agirlik === paketlemeData[i]?.list[listI]?.agirlik) &&
                                (listItem?.boy === paketlemeData[i]?.list[listI]?.boy) && 
                                (listItem?.cap === paketlemeData[i]?.list[listI]?.cap) && 
                                (listItem?.en === paketlemeData[i]?.list[listI]?.en) && 
                                (listItem?.sayisi === paketlemeData[i]?.list[listI]?.sayisi) && 
                                (listItem?.yukseklik === paketlemeData[i]?.list[listI]?.yukseklik)
                        })
    }).flat()


    //! routeData
const errorListRouteData = kayitliYukRouteSync?.map((item, i) => {

    return  (item?.adres === route[i]?.adres) &&
            (item?.locationType === route[i]?.locationType) &&
            (item?.order === route[i]?.order) &&
            (item?.saatAllTime === route[i]?.saatAllTime) &&
            (item?.saatBaslangic === route[i]?.saatBaslangic) &&
            (item?.saatBitis === route[i]?.saatBitis) &&
            (item?.locationData?.bolge === route[i]?.locationData?.bolge) &&
            (item?.locationData?.il === route[i]?.locationData?.il) &&
            (item?.locationData?.ilId === route[i]?.locationData?.ilId) &&
            (item?.locationData?.ilce === route[i]?.locationData?.ilce) &&
            (item?.locationData?.ilceId === route[i]?.locationData?.ilceId) &&
            (item?.locationData?.lat === route[i]?.locationData?.lat) &&
            (item?.locationData?.lng === route[i]?.locationData?.lng) &&
            (item?.locationData?.location === route[i]?.locationData?.location) &&
            (item?.locationData?.location === route[i]?.locationData?.location) &&
            (item?.sevkBicimleri.map((sevkItem, sevkI) =>{
                return  (sevkItem?.id === route[i]?.sevkBicimleri[sevkI]?.id) &&
                        (sevkItem?.status === route[i]?.sevkBicimleri[sevkI]?.status)
            }) )
}).flat()


return [...errorListYukData, ...errorListPaymentData, ...errorListAracData, ...errorListPaketlemeData, ...errorListRouteData]


} 

else{
    return [false]
}
}

export default getKayitliYukDiff